import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import Icons from 'bz-core-controls/icons';
import ClinicalEndpoints from 'bz-pronto-core/endpoints/clinical';

import ProntoReportStatus from 'bz-pronto-core/enum/pronto-report-status';
import Action from '../../../action-base';

@inject('vm')
@observer
class AcknowledgeAction extends React.Component {
  render() {
    if (!this.show) return null;

    return <Action label="Acknowledge" icon={Icons.edit} onClick={this.onClick} />;
  }

  @computed
  get show() {
    let { status } = this.props.vm.report;
    return status === ProntoReportStatus.Rejected;
  }

  @action.bound
  onClick(e) {
    let { store, report } = this.props.vm;
    let caseId = store.details.get('caseId');

    ClinicalEndpoints.onAcknowledge(caseId, report.id).then(() => {
      report.status = ProntoReportStatus.Acknowleged;
    });
  }
}

export default AcknowledgeAction;
